import commentIcon from '@jetbrains/icons/comment'
import Link from '@jetbrains/ring-ui-built/components/link/link'
import {SvgIcon} from '@jetbrains/teamcity-ui/dist/components'

import styles from './HeaderBanner.module.css'

type Props = {
  href: string
}

function HeaderBannerFeedback({href}: Props) {
  return (
    <Link className={styles.feedback} href={href} target={'_blank'} rel="noreferrer">
      <SvgIcon className={styles.feedbackIcon} icon={commentIcon} />
      {'Share feedback...'}
    </Link>
  )
}

export default HeaderBannerFeedback
